import { Card } from '@/components/ui/Card.tsx';
import { Skeleton } from '@/components/ui/Skeleton.tsx';

/** Nagłówek karty — wersalikowa etykieta nad kreską. */
const CardHeaderSkeleton = () => (
  <div className="border-b border-neutral-100 px-5 pb-3.5 pt-4">
    <Skeleton className="h-3 w-40" />
  </div>
);

const OptionRowSkeleton = () => (
  <div className="flex items-center gap-4 px-5 py-4">
    <div className="flex-1 space-y-1.5">
      <Skeleton className="h-4 w-44" />
      <Skeleton className="h-3 w-60" />
    </div>
    <div className="w-[200px] shrink-0 space-y-1.5">
      <Skeleton className="h-3 w-full" />
      <Skeleton className="h-2 w-full rounded-full" />
    </div>
    <Skeleton className="h-3 w-[100px] shrink-0" />
  </div>
);

/** Ładowanie zakładki „Opcje dodatkowe” — te same trzy bloki, bez treści. */
const TourOptionsTabSkeleton = () => (
  <div className="flex flex-col gap-4">
    <Card>
      <CardHeaderSkeleton />
      <div className="space-y-3 px-5 py-4">
        {[0, 1, 2].map((row) => (
          <Skeleton key={row} className="h-5 w-full" />
        ))}
      </div>
    </Card>

    <Card>
      <CardHeaderSkeleton />
      <div className="space-y-3 px-5 py-4">
        {[0, 1, 2, 3].map((row) => (
          <div key={row} className="flex items-center gap-2">
            <Skeleton className="h-4 w-[186px] shrink-0" />
            <Skeleton className="h-5 w-24 rounded-full" />
            <Skeleton className="h-5 w-28 rounded-full" />
          </div>
        ))}
      </div>
      <div className="border-y border-neutral-100 bg-neutral-50 px-5 py-3">
        <Skeleton className="h-4 w-64" />
      </div>
      <div className="space-y-3 px-4 py-4">
        {[0, 1, 2, 3, 4].map((row) => (
          <Skeleton key={row} className="h-8 w-full" />
        ))}
      </div>
    </Card>

    <Card>
      <CardHeaderSkeleton />
      {[0, 1, 2].map((row) => (
        <OptionRowSkeleton key={row} />
      ))}
    </Card>
  </div>
);

export default TourOptionsTabSkeleton;
